import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={167}
    height={123}
    viewBox="0 0 167 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={71} cy={58} r={58} fill="url(#paint0_radial_19_471)" />
    <circle cx={85} cy={66} r={28} fill="url(#paint1_radial_19_471)" />
    <circle cx={85} cy={66} r={28} fill="url(#paint2_radial_19_471)" />
    <circle cx={85} cy={66} r={28} fill="url(#paint3_radial_19_471)" />
    <circle cx={69.4062} cy={65.2494} r={1.40618} fill="#0C102B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.9119 63.4495C83.102 63.1109 83.5306 62.9904 83.8692 63.1805C86.5781 64.7009 90.0067 63.7374 91.5271 61.0285C91.7171 60.6898 92.1457 60.5694 92.4843 60.7595C92.8229 60.9495 92.9434 61.3781 92.7533 61.7167C90.8528 65.1029 86.5671 66.3072 83.1809 64.4067C82.8423 64.2167 82.7219 63.7881 82.9119 63.4495Z"
      fill="black"
    />
    <circle cx={100.342} cy={55.4062} r={1.40618} fill="#0C102B" />
    <path
      d="M111.5 56.2855C133.099 58.3865 148 62.8425 148 68C148 75.1797 119.122 81 83.5 81C47.8776 81 19 75.1797 19 68C19 62.6458 35.0597 58.0476 58 56.0555"
      stroke="url(#paint4_linear_19_471)"
    />
    <path
      d="M101.275 59.2186C116.508 60.7752 127.011 64.0186 127.001 67.7403C126.987 72.9212 106.605 77.0669 81.476 77C56.3472 76.9331 35.9874 72.679 36.0012 67.4981C36.0115 63.6345 47.3492 60.3466 63.5356 58.9522"
      stroke="url(#paint5_linear_19_471)"
    />
    <path
      d="M119.314 56.2951C146.94 58.9903 166 64.7067 166 71.323C166 80.5334 129.063 88 83.5 88C37.9365 88 1 80.5334 1 71.323C1 64.4544 21.5415 58.5556 50.8837 56"
      stroke="url(#paint6_linear_19_471)"
    />
    <ellipse
      opacity={0.9}
      cx={1.67628}
      cy={1.48818}
      rx={1.67628}
      ry={1.48818}
      transform="matrix(-0.954531 -0.298113 -0.320233 0.947339 82.2836 109.917)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.85}
      cx={1.63625}
      cy={1.58008}
      rx={1.63625}
      ry={1.58008}
      transform="matrix(0.972463 -0.233056 -0.251082 -0.967966 116.882 96.8788)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.87}
      cx={1.54935}
      cy={1.58351}
      rx={1.54935}
      ry={1.58351}
      transform="matrix(0.732921 -0.680314 -0.708751 -0.705459 46.2446 63.6761)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.92}
      cx={1.48545}
      cy={1.41096}
      rx={1.48545}
      ry={1.41096}
      transform="matrix(0.233545 -0.972346 -0.976251 -0.216641 117.972 62.0681)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.83}
      cx={1.495}
      cy={1.50734}
      rx={1.495}
      ry={1.50734}
      transform="matrix(0.644298 -0.764774 -0.789127 -0.61423 120.177 42.9827)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.71}
      cx={1.30807}
      cy={1.21381}
      rx={1.30807}
      ry={1.21381}
      transform="matrix(0.602992 0.797748 0.819865 -0.572557 56.2525 37.7832)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <ellipse
      opacity={0.92}
      cx={1.64721}
      cy={1.6979}
      rx={1.64721}
      ry={1.6979}
      transform="matrix(-0.354123 0.935199 0.943903 0.330224 121.276 31)"
      fill="#393FB9"
      fillOpacity={0.53}
    />
    <circle
      cx={130.563}
      cy={107.563}
      r={11.8907}
      transform="rotate(-105 130.563 107.563)"
      fill="url(#paint7_radial_19_471)"
    />
    <circle
      cx={0.666667}
      cy={0.666667}
      r={0.666667}
      transform="matrix(-1 0 0 1 139 105.667)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M131.93 105.48C131.84 105.319 131.637 105.262 131.476 105.352C130.192 106.073 128.567 105.616 127.846 104.332C127.756 104.172 127.553 104.115 127.392 104.205C127.231 104.295 127.174 104.498 127.264 104.658C128.165 106.264 130.197 106.835 131.803 105.934C131.963 105.844 132.02 105.641 131.93 105.48Z"
      fill="black"
    />
    <circle
      cx={0.666667}
      cy={0.666667}
      r={0.666667}
      transform="matrix(-1 0 0 1 124.333 101)"
      fill="#0C102B"
    />
    <circle
      cx={41.335}
      cy={38.335}
      r={4.59586}
      transform="rotate(57.9188 41.335 38.335)"
      fill="url(#paint8_radial_19_471)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C8.79086 0 7 1.79086 7 4V18C7 20.2091 8.79086 22 11 22H21.8508L25 28L28.1492 22H104C106.209 22 108 20.2091 108 18V4C108 1.79086 106.209 0 104 0H11Z"
      fill="#913983"
    />
    <path
      d="M17.6546 14L16.7906 10.032H17.6226L18.1026 12.816L18.6706 10.032H19.5826L20.1506 12.816L20.6306 10.032H21.4626L20.5986 14H19.7266L19.1266 11.136L18.5266 14H17.6546ZM23.9714 14.096C23.5874 14.096 23.2488 14.0107 22.9554 13.84C22.6621 13.664 22.4328 13.4213 22.2674 13.112C22.1021 12.8027 22.0194 12.4427 22.0194 12.032C22.0194 11.616 22.0994 11.2507 22.2594 10.936C22.4248 10.6213 22.6541 10.376 22.9474 10.2C23.2461 10.024 23.5901 9.936 23.9794 9.936C24.3634 9.936 24.6941 10.024 24.9714 10.2C25.2488 10.3707 25.4621 10.6 25.6114 10.888C25.7661 11.176 25.8434 11.4933 25.8434 11.84C25.8434 11.8933 25.8434 11.952 25.8434 12.016C25.8434 12.0747 25.8408 12.1413 25.8354 12.216H22.8514C22.8781 12.584 22.9981 12.864 23.2114 13.056C23.4248 13.2427 23.6754 13.336 23.9634 13.336C24.2141 13.336 24.4114 13.2853 24.5554 13.184C24.7048 13.0773 24.8141 12.9333 24.8834 12.752H25.7394C25.6434 13.1307 25.4434 13.4507 25.1394 13.712C24.8354 13.968 24.4461 14.096 23.9714 14.096ZM23.9714 10.672C23.7101 10.672 23.4781 10.752 23.2754 10.912C23.0728 11.0667 22.9421 11.2853 22.8834 11.568H24.9954C24.9741 11.3013 24.8701 11.0853 24.6834 10.92C24.4968 10.7547 24.2594 10.672 23.9714 10.672ZM47.9078 14.096C47.5291 14.096 47.1905 14.0107 46.8918 13.84C46.5931 13.6693 46.3585 13.4293 46.1878 13.12C46.0171 12.8053 45.9318 12.4373 45.9318 12.016C45.9318 11.5947 46.0171 11.2293 46.1878 10.92C46.3585 10.6053 46.5931 10.3627 46.8918 10.192C47.1905 10.0213 47.5318 9.936 47.9158 9.936C48.2998 9.936 48.6385 10.0213 48.9318 10.192C49.2305 10.3627 49.4625 10.6053 49.6278 10.92C49.7985 11.2293 49.8838 11.5947 49.8838 12.016C49.8838 12.4373 49.7985 12.8053 49.6278 13.12C49.4571 13.4293 49.2225 13.6693 48.9238 13.84C48.6305 14.0107 48.2918 14.096 47.9078 14.096ZM47.9078 13.288C48.1105 13.288 48.2971 13.2427 48.4678 13.152C48.6385 13.0613 48.7745 12.9227 48.8758 12.736C48.9825 12.544 49.0358 12.304 49.0358 12.016C49.0358 11.7227 48.9825 11.4827 48.8758 11.296C48.7745 11.1093 48.6385 10.9707 48.4678 10.88C48.3025 10.7893 48.1185 10.744 47.9158 10.744C47.7131 10.744 47.5265 10.7893 47.3558 10.88C47.1851 10.9707 47.0465 11.1093 46.9398 11.296C46.8385 11.4827 46.7878 11.7227 46.7878 12.016C46.7878 12.4533 46.8971 12.776 47.1158 12.984C47.3398 13.1867 47.6038 13.288 47.9078 13.288ZM52.3527 14.096C51.8727 14.096 51.5074 13.9493 51.2567 13.656C51.0114 13.3573 50.8887 12.9253 50.8887 12.36V10.032H51.7367V12.256C51.7367 12.5813 51.806 12.8373 51.9447 13.024C52.0887 13.2053 52.3074 13.296 52.6007 13.296C52.894 13.296 53.1394 13.1973 53.3367 13C53.534 12.8027 53.6327 12.5173 53.6327 12.144V10.032H54.4807V14H53.7447L53.6727 13.408H53.6327C53.526 13.6 53.3607 13.7627 53.1367 13.896C52.9127 14.0293 52.6514 14.096 52.3527 14.096ZM55.7176 14V13.264H56.6856V11.032C56.6856 10.856 56.6002 10.768 56.4296 10.768H55.7976V10.032H56.7496C56.9682 10.032 57.1469 10.096 57.2856 10.224C57.4242 10.3467 57.4936 10.52 57.4936 10.744V10.84H57.5336C57.5922 10.5413 57.7176 10.3173 57.9096 10.168C58.1069 10.0133 58.3922 9.936 58.7656 9.936H59.3816V10.832H58.5176C58.2029 10.832 57.9602 10.9413 57.7896 11.16C57.6189 11.3787 57.5336 11.64 57.5336 11.944V13.264H58.7656V14H55.7176ZM65.2473 15.76V10.032H65.9833L66.0473 10.64H66.0953C66.202 10.4427 66.362 10.2773 66.5753 10.144C66.794 10.0053 67.0526 9.936 67.3513 9.936C67.6606 9.936 67.9433 10.016 68.1993 10.176C68.4553 10.3307 68.658 10.5627 68.8073 10.872C68.962 11.176 69.0393 11.5573 69.0393 12.016C69.0393 12.4693 68.9593 12.8507 68.7993 13.16C68.6446 13.4693 68.434 13.704 68.1673 13.864C67.9006 14.0187 67.602 14.096 67.2713 14.096C66.978 14.096 66.7326 14.0373 66.5353 13.92C66.338 13.8027 66.1913 13.6693 66.0953 13.52V15.76H65.2473ZM67.1273 13.288C67.426 13.288 67.674 13.1813 67.8713 12.968C68.074 12.7547 68.1753 12.4347 68.1753 12.008C68.1753 11.5813 68.074 11.264 67.8713 11.056C67.674 10.848 67.426 10.744 67.1273 10.744C66.8233 10.744 66.57 10.8507 66.3673 11.064C66.17 11.272 66.0713 11.5893 66.0713 12.016C66.0713 12.4373 66.17 12.7547 66.3673 12.968C66.57 13.1813 66.8233 13.288 67.1273 13.288ZM70.1082 14V13.264H71.0762V11.032C71.0762 10.856 70.9909 10.768 70.8202 10.768H70.1882V10.032H71.1402C71.3589 10.032 71.5375 10.096 71.6762 10.224C71.8149 10.3467 71.8842 10.52 71.8842 10.744V10.84H71.9242C71.9829 10.5413 72.1082 10.3173 72.3002 10.168C72.4975 10.0133 72.7829 9.936 73.1562 9.936H73.7722V10.832H72.9082C72.5935 10.832 72.3509 10.9413 72.1802 11.16C72.0095 11.3787 71.9242 11.64 71.9242 11.944V13.264H73.1562V14H70.1082ZM76.6891 14.096C76.3104 14.096 75.9717 14.0107 75.6731 13.84C75.3744 13.6693 75.1397 13.4293 74.9691 13.12C74.7984 12.8053 74.7131 12.4373 74.7131 12.016C74.7131 11.5947 74.7984 11.2293 74.9691 10.92C75.1397 10.6053 75.3744 10.3627 75.6731 10.192C75.9717 10.0213 76.3131 9.936 76.6971 9.936C77.0811 9.936 77.4197 10.0213 77.7131 10.192C78.0117 10.3627 78.2437 10.6053 78.4091 10.92C78.5797 11.2293 78.6651 11.5947 78.6651 12.016C78.6651 12.4373 78.5797 12.8053 78.4091 13.12C78.2384 13.4293 78.0037 13.6693 77.7051 13.84C77.4117 14.0107 77.0731 14.096 76.6891 14.096ZM76.6891 13.288C76.8917 13.288 77.0784 13.2427 77.2491 13.152C77.4197 13.0613 77.5557 12.9227 77.6571 12.736C77.7637 12.544 77.8171 12.304 77.8171 12.016C77.8171 11.7227 77.7637 11.4827 77.6571 11.296C77.5557 11.1093 77.4197 10.9707 77.2491 10.88C77.0837 10.7893 76.8997 10.744 76.6971 10.744C76.4944 10.744 76.3077 10.7893 76.1371 10.88C75.9664 10.9707 75.8277 11.1093 75.7211 11.296C75.6197 11.4827 75.5691 11.7227 75.5691 12.016C75.5691 12.4533 75.6784 12.776 75.8971 12.984C76.1211 13.1867 76.3851 13.288 76.6891 13.288ZM81.2699 14.096C80.9393 14.096 80.6433 14.0187 80.3819 13.864C80.1206 13.704 79.9126 13.4693 79.7579 13.16C79.6086 12.8507 79.5339 12.4693 79.5339 12.016C79.5339 11.5627 79.6113 11.1813 79.7659 10.872C79.9206 10.5627 80.1286 10.3307 80.3899 10.176C80.6566 10.016 80.9526 9.936 81.2779 9.936C81.5819 9.936 81.8326 9.99467 82.0299 10.112C82.2273 10.224 82.3739 10.368 82.4699 10.544V8.24H83.3179V14H82.5899L82.5179 13.416H82.4699C82.3633 13.624 82.2113 13.7893 82.0139 13.912C81.8219 14.0347 81.5739 14.096 81.2699 14.096ZM81.4459 13.288C81.7499 13.288 82.0006 13.1813 82.1979 12.968C82.4006 12.7547 82.5019 12.4373 82.5019 12.016C82.5019 11.5893 82.4006 11.272 82.1979 11.064C82.0006 10.8507 81.7499 10.744 81.4459 10.744C81.1419 10.744 80.8886 10.8507 80.6859 11.064C80.4886 11.2773 80.3899 11.5973 80.3899 12.024C80.3899 12.4453 80.4886 12.7627 80.6859 12.976C80.8886 13.184 81.1419 13.288 81.4459 13.288ZM85.9308 14.096C85.4508 14.096 85.0855 13.9493 84.8348 13.656C84.5895 13.3573 84.4668 12.9253 84.4668 12.36V10.032H85.3148V12.256C85.3148 12.5813 85.3841 12.8373 85.5228 13.024C85.6668 13.2053 85.8855 13.296 86.1788 13.296C86.4721 13.296 86.7175 13.1973 86.9148 13C87.1121 12.8027 87.2108 12.5173 87.2108 12.144V10.032H88.0588V14H87.3228L87.2508 13.408H87.2108C87.1041 13.6 86.9388 13.7627 86.7148 13.896C86.4908 14.0293 86.2295 14.096 85.9308 14.096ZM91.1357 14.096C90.7677 14.096 90.437 14.0107 90.1437 13.84C89.8557 13.6693 89.629 13.4293 89.4637 13.12C89.2984 12.8053 89.2157 12.4373 89.2157 12.016C89.2157 11.5947 89.2984 11.2293 89.4637 10.92C89.6344 10.6107 89.8637 10.3707 90.1517 10.2C90.4397 10.024 90.7677 9.936 91.1357 9.936C91.6424 9.936 92.0504 10.064 92.3597 10.32C92.6744 10.5707 92.8744 10.9173 92.9597 11.36H92.0717C92.0184 11.168 91.909 11.016 91.7437 10.904C91.5837 10.792 91.3784 10.736 91.1277 10.736C90.9464 10.736 90.773 10.784 90.6077 10.88C90.4477 10.976 90.317 11.12 90.2157 11.312C90.1197 11.4987 90.0717 11.7333 90.0717 12.016C90.0717 12.2933 90.1197 12.528 90.2157 12.72C90.317 12.912 90.4477 13.0587 90.6077 13.16C90.773 13.256 90.9464 13.304 91.1277 13.304C91.3837 13.304 91.589 13.248 91.7437 13.136C91.8984 13.024 92.0077 12.8693 92.0717 12.672H92.9597C92.853 13.1093 92.645 13.456 92.3357 13.712C92.0264 13.968 91.6264 14.096 91.1357 14.096ZM96.3086 14C95.9192 14 95.6099 13.9067 95.3806 13.72C95.1512 13.528 95.0366 13.1893 95.0366 12.704V10.752H94.0366V10.032H94.6286C94.9006 10.032 95.0606 9.89867 95.1086 9.632L95.2286 8.992H95.8846V10.032H97.4526V10.752H95.8846V12.688C95.8846 12.896 95.9299 13.0427 96.0206 13.128C96.1166 13.208 96.2792 13.248 96.5086 13.248H97.4366V14H96.3086Z"
      fill="white"
    />
    <path
      d="M42.5535 9.08412C42.5535 12.9838 35.9481 16.82 35.9481 16.82C35.9481 16.82 29.3426 12.9838 29.3426 9.08412C29.3426 7.21239 30.8213 5.69505 32.6453 5.69505C34.4694 5.69505 35.9481 7.22953 35.9481 8.38039C35.9481 7.22953 37.4268 5.69505 39.2508 5.69505C41.0748 5.69505 42.5535 7.21239 42.5535 9.08412Z"
      fill="#D53C60"
    />
    <defs>
      <radialGradient
        id="paint0_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(71 58) rotate(90) scale(58)"
      >
        <stop stopColor="#646AFF" />
        <stop offset={1} stopColor="#212AFF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint1_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(75.5 51.5) rotate(61.5788) scale(48.3244)"
      >
        <stop stopColor="#F4B0FF" />
        <stop offset={0.68} stopColor="#0017FF" />
        <stop offset={1} stopColor="#002325" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.5 31.5) rotate(67.6771) scale(81.6165)"
      >
        <stop stopColor="#A4A5FF" stopOpacity={0} />
        <stop offset={0.479951} stopColor="#4346FF" stopOpacity={0.29} />
        <stop offset={1} stopColor="#91FFD7" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(85 63.5) rotate(125.803) scale(37.6065)"
      >
        <stop offset={0.622238} stopColor="#000AFF" stopOpacity={0} />
        <stop offset={1} stopColor="#0038FF" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_19_471"
        x1={83.5}
        y1={56.0555}
        x2={83.5}
        y2={81}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_19_471"
        x1={81.5239}
        y1={59}
        x2={81.476}
        y2={77}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_19_471"
        x1={83.5}
        y1={56}
        x2={83.5}
        y2={88}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.035} stopColor="#9301FF" stopOpacity={0} />
        <stop offset={0.51} stopColor="#902FD7" />
        <stop offset={1} stopColor="#3C73FF" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(136.178 102.278) rotate(108.104) scale(18.07)"
      >
        <stop stopColor="#FFB6FC" />
        <stop offset={1} stopColor="#A9318F" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_19_471"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.5053 36.2924) rotate(108.104) scale(6.98421)"
      >
        <stop stopColor="#B9C4FF" />
        <stop offset={1} stopColor="#4664FF" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgComponent;
